import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { officeApi } from "../../api/config";
import Emty from "../../components/Emty/Emty";
import Infinite from "../../components/Infinite/Infinite";
import { PgInter } from "../../interface/interface";
import { formatDate } from "../../lib/lib";
import "./css/index.css";

function Coupon() {
  const navigate = useNavigate();
  const [Data, setData] = useState<any[]>([]);
  const [pg, setPg] = useState<PgInter | null>(null);
  const [Delete, setDelete] = useState<undefined | number>(undefined);

  const RemoveCoupon = useCallback(
    (id: string, idx: number) => {
      officeApi.delete(`/cstm/cpon/${id}`).then(({ data: { sts_fg } }) => {
        if (sts_fg) {
          let clone = Data.slice();
          clone.splice(idx, 1);
          setData(clone);
        }
      });
    },
    [Data]
  );
  const PagingUpdate = useCallback(() => {
    if (pg) {
      const { page_next, page_last, page_cur } = pg;
      if (page_cur < page_last) {
        officeApi
          .get(`/cstm/cpon?row_limit_cnt=10&page=${page_next}`)
          .then(({ data: { sts_fg, succ_obj } }) => {
            if (sts_fg && succ_obj.pg) {
              setPg(succ_obj.pg);
              let clone = Data ? Data.slice() : [];
              clone = [...clone, ...succ_obj.lst];
              setData(clone);
            }
          });
      }
    }
  }, [pg, Data]);
  useEffect(() => {
    officeApi
      .get("/cstm/cpon?row_limit_cnt=10")
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setPg(succ_obj.pg);
          setData(succ_obj.lst);
        }
      });
    return () => {};
  }, []);
  return (
    <main className="coupon-page">
      <div className="wrapper">
        <div className="title">
          <div className="left">
            <p>쿠폰 관리</p>
          </div>
          <div className="right">
            <Link to="/insert/invitation" className="greenbox">
              <div className="greenbox">인비테이션 발급</div>
            </Link>
            <Link to="/insert/coupon" className="bluebox">
              <div className="bluebox">쿠폰 발급</div>
            </Link>
          </div>
        </div>
        <div className="sub">
          <div className="menu">
            <div className="name1">유형</div>
            <div className="name2">쿠폰명</div>
            <div className="name3">할인율</div>
            <div className="name4">만료일</div>
            <div className="name5">삭제하기</div>
          </div>
        </div>
        <div className="list">
          {Data.length > 0 ? (
            <>
              {Data.map(
                (
                  {
                    cpon_type_cd,
                    cpon_nm,
                    cpon_discnt_rate,
                    cpon_apply_en_at,
                    cpon_id,
                  },
                  idx
                ) => {
                  return (
                    <div key={idx} className={`box ${cpon_type_cd}`}>
                      <div className="type">
                        {cpon_type_cd === "normal" ? "쿠폰" : "인비테이션"}
                      </div>
                      <div className="name">{cpon_nm}</div>
                      <div className="rate">{cpon_discnt_rate}%</div>
                      <div className="registration">
                        {cpon_apply_en_at
                          ? formatDate(cpon_apply_en_at, "-")
                          : "-"}
                      </div>
                      <button
                        className="nav-btn"
                        onClick={() => {
                          navigate("/etc/coupon/list", {
                            state: cpon_id,
                          });
                        }}
                      >
                        발급대상
                      </button>
                      <div className={`img `}>
                        <img
                          src="/assets/common/delete.svg"
                          onClick={() => {
                            setDelete(idx);
                          }}
                          alt="삭제"
                        ></img>
                      </div>
                      <div
                        className={`delete ${Delete === idx ? "delete1" : ""}`}
                      >
                        <div className="title">쿠폰을 삭제하시겠습니까?</div>
                        <div
                          className="deleteBox"
                          onClick={() => {
                            RemoveCoupon(cpon_id, idx);
                            setDelete(undefined);
                          }}
                        >
                          삭제하기
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
              <Infinite PagingUpdate={PagingUpdate} />
            </>
          ) : (
            <Emty />
          )}
        </div>
      </div>
    </main>
  );
}

export default Coupon;
